import { defineSlotRecipe } from '@chakra-ui/react'
import { sliderAnatomy } from '@chakra-ui/react/anatomy'

export const sliderSlotRecipe = defineSlotRecipe({
    slots: sliderAnatomy.keys(),
    variants: {
        variant: {
            gigi: {
                thumb: {
                    width: '12px',
                    height: '12px',
                    _light: {
                        background: 'dark.700',
                    },
                    _dark: {
                        background: 'white',
                    },
                },
                track: {
                    _vertical: {
                        width: '2px',
                    },
                    _horizontal: {
                        height: '2px',
                    },
                    _light: {
                        background: 'surface.medium',
                    },
                    _dark: {
                        background: 'gray.700',
                    },
                },
            },
        },
    },
})
